import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { Spin } from 'antd';
import MainLayout from './layouts/MainLayout';
import { AuthGuard } from './components/AuthGuard';
import { useHistoryInit } from './utils/navigation';
import { routes } from './routes/routes';

const PageLoading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" />
  </div>
);

/**
 * Protected Layout wrapper
 * Ensures auth is validated before rendering the main layout
 */
function ProtectedLayout() {
  return (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  );
}

export function App() {
  // Initialize history ref for compatibility
  useHistoryInit();

  // Separate public and protected routes
  const publicPaths = ['/login', '/mfa-enrollment', '/account-action'];
  const publicRoutes = routes.filter((r) => publicPaths.includes(r.path));
  const protectedRoutes = routes.filter((r) => !publicPaths.includes(r.path));

  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        {/* Public routes - no auth required */}
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={<route.component />} />
        ))}

        {/* Protected routes - require valid auth token */}
        {/* Catch-all 404 is inside ProtectedLayout so it's handled by the tab system */}
        <Route element={<ProtectedLayout />}>
          {protectedRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={<route.component />} />
          ))}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          {/* 404 for unknown protected routes - handled within tabs by KeepAliveOutlet */}
          <Route path="*" element={null} />
        </Route>
      </Routes>
    </Suspense>
  );
}

